export function useNavaChat() {
    const navaChatElement = document.getElementById("nava-chat");

    function show() {
        if (!navaChatElement) return;
        
        navaChatElement!.style.display = "block";
        navaChatElement!.classList.add("show-nava-chat");
    };

    function hide() {
        if (!navaChatElement) return;

        navaChatElement.style.display = "none";
        navaChatElement.classList.remove("show-nava-chat");
    };

    return { show, hide };
}
